import axiosClient from "../../utils/axiosInstance";

export const loadBokehPackageAsync = () => {};
export const retrieveBokehAsync = (uniqueValidator: any) => {
  const response = axiosClient().get(
    `/bokeh-widget?uniqueValidator=${uniqueValidator}`,
  );
  return response;
};
